import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

type TypeSearchParams = {
    [key: string]: string | number | string[] | number[] | null | undefined;
};

/**
 * @param {boolean} useMultipleKeys - used for keys with array of values, true = key=value1&key=value2. false = key=value1,value2
 */
const useUpdateSearchParams = (useMultipleKeys = true) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const updateSearchParams = useCallback(
        (newParams: TypeSearchParams) => {
            const updatedParams = new URLSearchParams(searchParams);

            Object.keys(newParams).forEach((key) => {
                let newParamValue = newParams[key];

                if (!newParamValue) {
                    newParamValue = '';
                } else if (Array.isArray(newParamValue)) {
                    if (useMultipleKeys) {
                        updatedParams.delete(key);
                        newParamValue.forEach((value) => {
                            updatedParams.append(key, value.toString());
                        });
                    } else {
                        updatedParams.set(key, newParamValue.join(','));
                    }
                } else {
                    updatedParams.set(key, newParamValue.toString());
                }
            });

            setSearchParams(updatedParams);
        },
        [searchParams, setSearchParams, useMultipleKeys]
    );

    return updateSearchParams;
};

export default useUpdateSearchParams;
